import Vue from 'vue'
import Toasted from 'vue-toasted'
import 'material-icons/iconfont/material-icons.css'

Vue.use(Toasted, {
  iconPack: 'material'
})

const toaster = {

  onSuccess (message) {
    Vue.toasted.success(message, {
      icon: 'check',
      position: 'top-right',
      duration: 5000
    })
  },

  onFailure (message) {
    Vue.toasted.error(message, {
      icon: 'error',
      position: 'top-right',
      duration: 5000
    })
  }
}

export default toaster
